import { Client } from '@widgetbot/embed-api';
import * as React from 'react';
import { Embed, Root } from './elements';
import { generateUUID, searchParams } from './util';
class WidgetBot extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            url: null,
            id: generateUUID()
        };
        this.api = new Client({
            id: this.state.id,
            iframe: null
        });
    }
    static getDerivedStateFromProps(props, state) {
        const url = `${props.shard}/channels/${props.server}${props.channel ? `/${props.channel}` : ''}/${searchParams(Object.assign(Object.assign({}, props.options), { api: state.id }))}`;
        return { url };
    }
    componentDidMount() {
        const { onAPI } = this.props;
        if (onAPI)
            onAPI(this.api);
    }
    render() {
        const { defer, className, style, height, width, focusable } = this.props;
        return (React.createElement("div", { className: className, style: Object.assign(Object.assign({}, Root({ width, height })), style) },
            React.createElement("iframe", { src: defer ? '' : this.state.url, ref: ref => (this.api.iframe = ref), style: Embed, tabIndex: focusable ? null : -1 })));
    }
}
WidgetBot.defaultProps = {
    server: '186188135095336960',
    shard: 'https://widgetbot.io',
    options: {},
    defer: false,
    focusable: true
};
export default WidgetBot;
export * from '@widgetbot/embed-api';
export { Client as API } from '@widgetbot/embed-api';
//# sourceMappingURL=index.js.map